import { toMapStateToLinkProps } from '@core/external-links/withExtHrefs';
import { Links } from '@core/links';
import type { ContractAgreement } from '@engage/members/models';
import { useReduxState } from '@engage/redux/hooks';
import { ContractType } from './acceptTermsEnums';
import type { Contract } from './TermButton';

export const useContracts = (contractAgreements: ContractAgreement[]) => {
  const links = useReduxState(
    toMapStateToLinkProps({
      tos: Links.tos,
      privacy: Links.privacy,
      membershipTerms: Links.membershipTerms,
      onePeloton: Links.peloton,
    }),
  );
  const contractLinks = {
    [ContractType.PrivacyPolicy]: links.privacy,
    [ContractType.MembershipTerms]: links.membershipTerms,
    [ContractType.TermsOfService]: links.tos,
  };

  const toContractLink = (contract: ContractAgreement): string => {
    // @ts-expect-error (TS7053): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ privacy_policy: string; subscription_terms: string; terms_of_service: string; }'
    return contractLinks[contract.contractType];
  };

  const toContract = (contract: ContractAgreement): Contract => {
    const href = toContractLink(contract);

    return {
      href,
      type: contract.contractType,
      displayName: contract.contractDisplayName,
      createdAt: contract.contractCreatedAt,
      id: contract.contractId,
      agreedAt: contract.agreedAt,
      requiredMemberAction: contract.requiredMemberAction,
    };
  };

  return contractAgreements.map(toContract);
};
